export default "__VITE_ASSET__zlHPQHnq__"